// libraries
import React from 'react';

import { T } from 'react-translator-component';
import styled from 'styled-components';

// assets and components
import closeIcon from '../../assets/small-close-button.png';
import SearchIcon from '../atoms/icons/SearchIcon';
import { SearchInput } from '../atoms/SearchInput';

export const Search = ({
  className = '',
  placeholder = T('Search stations'),
  action = (e) => {},
  value = '',
  closeBtn,
  onKeyPress = (e) => {},
  mode = 'default',
  inputArray = [],
  setInputArray = (e) => {},
  removeTagFunction = (e) => {},
}) => {
  return mode === 'default' ? (
    <Div className={className}>
      <SearchInput onChange={(x) => action(x.target.value)} value={value} className='input' type='search' name='search' placeholder={placeholder} id='search' mode={mode} />
      {value && <img onClick={closeBtn} className='close_list_button' src={closeIcon} alt='close list button' />}
      <SearchIcon fill={'rgba(0, 0, 0, 0.5)'} />
    </Div>
  ) : mode === 'tag' ? (
    <SearchTagWrapper className={className} style={{ width: '60%' }}>
      <SearchInput
        value={value}
        onChange={(x) => action(x.target.value)}
        className='input'
        type='search'
        name='search'
        placeholder={placeholder}
        id='search'
        closeBtn={closeBtn}
        onKeyPress={onKeyPress}
        mode={mode}
        inputArray={inputArray}
        setInputArray={setInputArray}
        removeTagFunction={removeTagFunction}
       />
    </SearchTagWrapper>
  ) : null;
};

const SearchTagWrapper = styled.div`
height: auto;
position: relative;
font-size: 12px;

svg {
  position: absolute;
  top: 50%;
  transform: translateY(-55%) scale(1.1);
  right: 5%;
}

.close_list_button {
  position: absolute;
  width: 10px;
  top: 50%;
  transform: translateY(-55%) scale(1.1);
  right: 12%;
  transition: 300ms ease;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }
}
`;

const Div = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  font-size: 12px;

  .input&:not(.remove-tag-button) {
    width: 100%;
    padding: 0 12% 0 5%;
    height: 40px;
    background-color: #fff;
    color: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    margin-bottom: 3px;
    outline: none;

    &::placeholder {
      color: rgba(0, 0, 0, 0.5);
    }
  }

  svg {
    position: absolute;
    top: 50%;
    transform: translateY(-55%) scale(1.1);
    right: 5%;
  }

  .close_list_button {
    position: absolute;
    width: 10px;
    top: 50%;
    transform: translateY(-55%) scale(1.1);
    right: 12%;
    transition: 300ms ease;
    cursor: pointer;

    &:hover {
      opacity: 0.6;
    }
  }
`;
